module.exports = __webpack_public_path__ + "static/media/icon_50.5c9752de.svg";